// @flow

import React from 'react';
import {IconButton, Typography, makeStyles} from '@material-ui/core';
import {Edit, Delete, DragIndicator} from '@material-ui/icons';

import StarIcon from '../../../../../../elements/icons/StarIcon';

const useStyles = makeStyles(theme => ({
  header: {
    width: '100%',
    background: '#158CFD',
    borderRadius: 12,
    padding: theme.spacing(1, 1.5),
  },
  text: {
    fontWeight: 600,
    fontSize: 14,
    color: 'white',
  },
  count: {
    background: '#0000001A',
    padding: theme.spacing(1),
    flexShrink: 0,
    width: 30,
    height: 30,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
  },
  content: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  leftContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  star: {
    '&[data-main="true"]': {
      color: '#F7D144',
    },
  },
}));

type Props = {
  count: number,
  name: string,
  isMain?: boolean,
  color: string,
  onStarClick?: () => void,
  onEdit?: () => void,
  onDelete?: () => void,
  dragHandleProps?: any,
};

export default function FunnelColumnHeader(props: Props) {
  const {
    count,
    name,
    isMain,
    color,
    onStarClick,
    onDelete,
    onEdit,
    dragHandleProps,
  } = props;
  const classes = useStyles();

  return (
    <div className={classes.header} style={{background: color}}>
      <div className={classes.content}>
        <div className={classes.leftContent}>
          <div
            {...dragHandleProps}
            style={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'grab',
              color: 'white',
            }}
          >
            <DragIndicator fontSize="small" />
          </div>
          <IconButton
            size="small"
            className={classes.star}
            data-main={isMain}
            onClick={onStarClick}
          >
            <StarIcon />
          </IconButton>
          <Typography component={'span'} className={classes.text}>
            {name}
          </Typography>
          <div className={classes.count}>
            <Typography className={classes.text}>{count}</Typography>
          </div>
        </div>

        <IconButton size="small" onClick={onEdit}>
          <Edit fontSize="small" />
        </IconButton>
        {!isMain && (
          <IconButton
            size="small"
            onClick={onDelete}
            className={classes.deleteButton}
          >
            <Delete fontSize="small" />
          </IconButton>
        )}
      </div>
    </div>
  );
}
